import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {capitalize} from 'util/NameUtil';
import {WorklistType, worklistTypeDisplayName} from 'worklists/WorklistConstants';

import {COLUMN_TYPE, ScannedWorklistItem} from './BarcodeConstants';
import ScannedWorklistItemRow, {getScannedTableColumns} from './ScannedWorklistItemRow';

function getColumnTitle(type: COLUMN_TYPE, worklistType: WorklistType): string {
  if (type === COLUMN_TYPE.CHIP) {
    return capitalize(worklistTypeDisplayName(worklistType));
  } else if (type === COLUMN_TYPE.SCANNED_IDENTIFIER) {
    return worklistType === WorklistType.BIOENTITY ? 'Registry ID' : 'Barcode';
  } else {
    return type;
  }
}

/**
 * Presentational component to render barcodes and their worklist items. Tested in ScanIntoWorklistModal-test.
 */
export default function ScannedWorklistItemsTable({
  visibleScannedWorklistItems,
  handleRemoveRow,
  worklistType,
}: {
  visibleScannedWorklistItems: Array<ScannedWorklistItem>;
  handleRemoveRow: (scannedWorklistItem: ScannedWorklistItem) => void;
  worklistType: WorklistType;
}): JSX.Element {
  return (
    <>
      <Row>
        {getScannedTableColumns(worklistType).map(({type, width}) => (
          <Col sm={width} key={type}>
            <h5>{getColumnTitle(type, worklistType)}</h5>
          </Col>
        ))}
      </Row>
      {visibleScannedWorklistItems.map((item, index) => (
        <ScannedWorklistItemRow
          key={index}
          scannedWorklistItem={item}
          handleRemoveRow={handleRemoveRow}
          worklistType={worklistType}
        />
      ))}
    </>
  );
}
